import React, { ReactNode } from 'react';

import { TableCell, TableHeader } from '~/components/table';

import styles from './CustomComponents.module.scss';

export const CustomLink = ({
  href,
  children,
  title,
}: {
  href?: string;
  children?: ReactNode;
  title?: string;
}) => (
  <a
    className={styles.markdownA}
    href={href}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

export const CustomTableCell = ({ children }: { children?: ReactNode }) => (
  <TableCell>{children}</TableCell>
);

export const CustomTableHeader = ({ children }: { children?: ReactNode }) => (
  <TableHeader>{children}</TableHeader>
);

export const CustomTable = ({ children }: { children?: ReactNode }) => (
  <div className={styles.markdownTableContainer}>
    <table className={styles.markdownTable}>{children}</table>
  </div>
);
